import globalTheme, { muiTheme } from '../global'

const Tabs = {
	MuiTabs: {
		defaultProps: {
			indicatorColor: 'primary',
		},
	},
	MuiTab: {
		defaultProps: {
			disableRipple: true,
		},
		styleOverrides: {
			root: {
				color: globalTheme.palette.primary.main,
				fontSize: muiTheme.typography.pxToRem(14),
				minHeight: 56,
				maxWidth: 'none',
				minWidth: 159,
				textTransform: 'none',
				'&:hover': {
					backgroundColor: 'rgba(237, 237, 237, 0.5)',
				},
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.light,
				},
			},
		},
	},
}

export default Tabs
